import React, { useEffect, useState } from 'react';
import { Empty, Spin } from 'antd';
import Scrollbars from 'react-custom-scrollbars';
import task from '../../images/task.png';
import { taskPictureList } from '../../../../actions/majorProjects';
import UploadItem from '../../../resource-wrap/common-wrap/pictureItem/upLoadItem';


//任务图片页面
const  TaskPicture = (props) => {

    const [loading, setLoading] = useState(false);
    const [pictureList, setPictureList] = useState([]);

    useEffect(() => {
        search();
    },[])

    const search = (current) => {
        let formData={
          id: props.id, ///项目id
          resourceType: 2
      }
      setLoading(true);
      taskPictureList(formData,function(res){
          if(res.code === 0){
            setLoading(false)
            let data1 = [];
            res.data && res.data.length > 0 && res.data.map(item => data1.push({ taskName: item.interview.title,  picData: item.picture}));
            setPictureList(data1);
          }   
      })
    }

    return(
        <div className="taskPicture">
            <Scrollbars style={{ height: 570}}>
                {
                    loading ? <Spin className="loading" /> :
                    pictureList.length === 0 ? <Empty className="noData"/> : 
                    pictureList.map((item, index) => (
                        <div className="box" key={index}>
                        <div className="part_1">
                            <img src={task} alt="" />
                    <span>{item.taskName}</span>
                        </div>
                        <div className="part_2">
                        <UploadItem fileList={item.picData}  fileType="图片" showIcon={['eye','download']}/>
                        </div>
                    </div>
                    ))    
                }
            </Scrollbars> 
        </div>
    )
}

export default TaskPicture